module.exports = __webpack_public_path__ + "img/avatar_1.630d6ee0.png";